<div class="interactive-chart-container">
  <!-- Interactive hint for scatter plots -->
  <div *ngIf="chartType === 'scatter'" class="chart-hint">
    <span>Click and drag to select data points</span>
  </div>
  
  <!-- Chart Canvas -->
  <div class="chart-wrapper" [class.has-selection-overlay]="showDataTable">
    <canvas #chartCanvas></canvas>
    <button 
      *ngIf="showDataTable && selectedData.length > 0"
      class="clear-selection-button"
      (click)="clearSelection()"
      aria-label="Clear selection">
      Clear Selection
    </button>
  </div>

  <!-- Selected Data Table -->
  <div *ngIf="showDataTable && selectedData.length > 0" class="data-table-section">
    <div class="table-container">
      <table mat-table [dataSource]="selectedData">
        <!-- Dynamic columns -->
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
          <td mat-cell *matCellDef="let row">
            <div class="cell-content">{{ row[column] }}</div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoadingData" class="loading-overlay">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading data...</p>
  </div>
</div>
